import React, { useState } from 'react';
import Navbar from '../components/navbar/navbar';
import Footer from '../components/footer/footer';
import CustomDropdown from '../components/CustomDropdown';
import './Help.css';
import SEO from '../components/SEO';

const HELP_CATEGORIES = [
  { title: "Riding with 9tro", count: "12 articles", icon: "🚗" },
  { title: "Package Deliveries", count: "8 articles", icon: "📦" },
  { title: "Eats & Chef Orders", count: "15 articles", icon: "🍔" },
  { title: "Account & Wallet", count: "10 articles", icon: "💳" }
];

const ARTICLES = [
  { q: "How do I request a delivery refund?", a: "Go to your history tab, choose the delivery, click 'Report Delivery Issue', and submit your refund request details. Our team will review within 24 hours." },
  { q: "How can I apply as a driver?", a: "Click on 'Apply as a driver' in the footer, submit your registration data, vehicle information, and await background review approval." },
  { q: "What is the flat subscription cost for chefs?", a: "Chefs do not pay a subscription. Instead, we deduct a small 5% commission fee per customer food order." }
];

function Help() {
  const [searchQuery, setSearchQuery] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [supportMessage, setSupportMessage] = useState({ name: '', email: '', role: 'Rider', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!supportMessage.name || !supportMessage.email || !supportMessage.message) {
      alert("Please fill in all required fields.");
      return;
    }
    setFormSubmitted(true);
  };

  const filteredArticles = searchQuery === '' ? ARTICLES : ARTICLES.filter(art => 
    art.q.toLowerCase().includes(searchQuery.toLowerCase()) || 
    art.a.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="help-page-wrapper">
      <SEO 
        title="Help Center & Support Desk"
        description="Search support topics, browse platform guides, and submit customer service tickets to our support crew."
        url="https://www.9troride.com/help"
      />
      <Navbar showSubNavbar={false} />

      <section className="help-hero">
        <div className="help-hero-container">
          <span className="hero-tag">Help Desk</span>
          <h1>How can we help you today?</h1>
          <div className="help-search-bar">
            <span className="search-icon">🔍</span>
            <input 
              type="text" 
              placeholder="Search articles (e.g. refunds, subscription, account)..." 
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
      </section>

      <section className="help-categories-section">
        <div className="help-categories-container">
          <h2>Browse Help Categories</h2>
          <div className="help-categories-grid">
            {HELP_CATEGORIES.map((cat, idx) => (
              <div key={idx} className="help-category-card">
                <span className="cat-icon">{cat.icon}</span>
                <h3>{cat.title}</h3>
                <span className="cat-count">{cat.count}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="articles-section">
        <div className="articles-container">
          <h2>Popular Articles</h2>
          <div className="articles-list">
            {filteredArticles.length === 0 ? (
              <p className="no-articles">No articles match your search query.</p>
            ) : (
              filteredArticles.map((art, idx) => (
                <div key={idx} className="article-item">
                  <h3>{art.q}</h3>
                  <p>{art.a}</p>
                </div>
              ))
            )}
          </div>
        </div>
      </section>

      <section className="contact-support-section">
        <div className="contact-support-container">
          <div className="contact-info">
            <h2>Still need assistance?</h2>
            <p>Our dedicated support crew is available 24/7. Submit a support ticket and we will respond to you via email shortly.</p>
            <div className="support-email">
              <span>📧</span>
              <strong>support@9troride.com</strong>
            </div>
          </div>

          <div className="contact-form-card">
            {formSubmitted ? (
              <div className="form-success">
                <span>✅</span>
                <h3>Ticket submitted successfully</h3>
                <p>Thank you for reaching out. We have logged your request and our support crew will email you shortly.</p>
                <button className="reset-form-btn" onClick={() => { setFormSubmitted(false); setSupportMessage({ name: '', email: '', role: 'Rider', message: '' }); }}>Submit another ticket</button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="support-form">
                <div className="form-group">
                  <label htmlFor="supportName">Your Name</label>
                  <input 
                    type="text" 
                    id="supportName" 
                    required 
                    value={supportMessage.name}
                    onChange={(e) => setSupportMessage({...supportMessage, name: e.target.value})}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="supportEmail">Your Email</label>
                  <input 
                    type="email" 
                    id="supportEmail" 
                    required 
                    value={supportMessage.email}
                    onChange={(e) => setSupportMessage({...supportMessage, email: e.target.value})}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="supportRole">What describes you?</label>
                  <CustomDropdown 
                    options={[
                      { value: "Rider", label: "Rider / Customer" },
                      { value: "Driver", label: "Partner Driver" },
                      { value: "Courier", label: "Courier Partner" },
                      { value: "Chef", label: "Chef Partner" }
                    ]}
                    value={supportMessage.role}
                    onChange={(val) => setSupportMessage({...supportMessage, role: val})}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="supportMsg">Message / Issue Details</label>
                  <textarea 
                    id="supportMsg" 
                    rows="4" 
                    required 
                    value={supportMessage.message}
                    onChange={(e) => setSupportMessage({...supportMessage, message: e.target.value})}
                  />
                </div>
                <button type="submit" className="submit-ticket-btn">Submit Ticket</button>
              </form>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Help;
